import { FormikValues } from 'formik';
import { Dispatch } from 'redux';
import { ApiApplication } from '../http';
import { applicationActions } from '../slices/application-slice';

const {
  setApplicationRequestStart,
  setApplicationRequestSuccess,
  setApplicationRequestFailure,
  setApplicationRequestDefault,

  setApplicationListRequest,
  setApplicationListSuccess,
  setApplicationListFailure,
  setApplicationListDefault,

  setApplicationOneRequest,
  setApplicationOneSuccess,
  setApplicationOneFailure,
  setApplicationOneDefault,

  setApplicationStatsRequest,
  setApplicationStatsSuccess,
  setApplicationStatsFailure,
} = applicationActions;

//List
export const getApplications =
  (params?: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setApplicationListRequest());
    try {
      const data = await ApiApplication.fetchAll(params);
      dispatch(setApplicationListSuccess(data));
    } catch ({ message }: any) {
      dispatch(setApplicationListFailure({ message }));
    }
  };
export const clearApplications = () => async (dispatch: Dispatch<any>) => {
  dispatch(setApplicationListDefault());
};

//One
export const getApplication = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setApplicationOneRequest());
  try {
    const data = await ApiApplication.fetchOne(id);
    dispatch(setApplicationOneSuccess(data));
  } catch ({ message }: any) {
    dispatch(setApplicationOneFailure({ message }));
  }
};
export const clearApplication = () => async (dispatch: Dispatch<any>) => {
  dispatch(setApplicationOneDefault());
};

//Create
export const createApplication = (data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
  dispatch(setApplicationRequestStart());
  return new Promise((resolve, reject) => {
    ApiApplication.createOne(data)
      .then((res) => {
        dispatch(setApplicationRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setApplicationRequestFailure({ message: res?.message }));
        reject(res);
      });
  });
};

//Edit
export const editApplication =
  (id: string | number, data: Record<string, any>) => async (dispatch: Dispatch<any>) => {
    dispatch(setApplicationRequestStart());
    return new Promise((resolve, reject) => {
      ApiApplication.updateOne(id, data)
        .then((res) => {
          dispatch(setApplicationRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setApplicationRequestFailure({ message: res?.message }));
          reject(res);
        });
    });
  };

//Confirm
export const confirmApplication =
  (id: string | number, values: FormikValues) => async (dispatch: Dispatch<any>) => {
    dispatch(setApplicationRequestStart());
    return new Promise((resolve, reject) => {
      ApiApplication.confirmOne(id, values)
        .then((res) => {
          dispatch(setApplicationRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setApplicationRequestFailure(res));
          reject(res);
        });
    });
  };

//Decline
export const declineApplication =
  (id: string | number, values: FormikValues) => async (dispatch: Dispatch<any>) => {
    dispatch(setApplicationRequestStart());
    return new Promise((resolve, reject) => {
      ApiApplication.declineOne(id, values)
        .then((res) => {
          dispatch(setApplicationRequestSuccess());
          resolve(res);
        })
        .catch((res) => {
          dispatch(setApplicationRequestFailure(res));
          reject(res);
        });
    });
  };

//Delete
export const deleteApplication = (id: string | number) => async (dispatch: Dispatch<any>) => {
  dispatch(setApplicationRequestStart());
  return new Promise((resolve, reject) => {
    ApiApplication.deleteOne(id)
      .then((res) => {
        dispatch(setApplicationRequestSuccess());
        resolve(res);
      })
      .catch((res) => {
        dispatch(setApplicationRequestFailure(res));
        reject(res);
      });
  });
};

//Clear request
export const clearApplicationRequest = () => async (dispatch: Dispatch<any>) => {
  dispatch(setApplicationRequestDefault());
};

export const getApplicationStats = () => async (dispatch: Dispatch<any>) => {
  dispatch(setApplicationStatsRequest());
  try {
    const data = await ApiApplication.fetchStats();
    dispatch(setApplicationStatsSuccess(data));
  } catch ({ message }: any) {
    dispatch(setApplicationStatsFailure({ message }));
  }
};
